import React from 'react';
import { GlobalContext } from '../../store/GlobalContext';
import Modal from './Modal';

const ModalInformacao = () => {
  const { modalInfoData, setModalInfoData } = React.useContext(GlobalContext);
  if (modalInfoData === null) {
    return null;
  }

  return (
    <Modal
      titulo={modalInfoData.titulo || 'Informação'}
      aberto={modalInfoData.visible === true}
      setAberto={() => setModalInfoData({ visible: false })}
    >
      <div>
        {modalInfoData.texto}</div>
      <br />
      <br />
      <div className="botoes">
        <button
          className="basico"
          onClick={() => setModalInfoData({ visible: false })}
        >
          OK
        </button>
      </div>
    </Modal>
  );
};

export default ModalInformacao;
